<template>
  <div>
    <Breadcrumbs />
    <div class="wrapper mt-5 mb-5 pb-5">
      <div class="container">
        <div class="login-box border border-2">
          <h1 class="text-bg-secondary text-center text-uppercase mx-auto p-3 p-md-4 rounded rounded-3 mw-custom" style="--w:440">{{ $t("login") }}</h1>
          <div class="row row-cols-1 row-cols-md-2">
            <div class="col d-flex flex-column">
              <h2 class="text-black mb-4">{{ $t("No_account") }}</h2>
              <p class="mb-5 login-desc">{{ $t("register_info") }}</p>
              <router-link :to="{ name: 'signUp' }" class="btn create-acc-btn btn-primary btn-lg fw-bold mt-auto w-100">
                {{ $t("create_account") }}
              </router-link>
            </div>
            <div class="col">
              <h2 class="text-black mb-4">{{ $t("registered_customers") }}</h2>
              <p class="login-desc">{{ $t("account_login") }}</p>
              <b-form @submit.prevent="onLoginFormSubmit" novalidate>
                <b-form-group
                  class="mb-4 pb-2 form-label"
                  id="email-group"
                  :label="$t('form_email') + '*'"
                  label-for="email"
                >
                  <b-form-input
                    id="email"
                    v-model="loginData.email"
                    type="text"
                    :state="loginValidation.emailState"
                    @blur="validateEmail"
                    :placeholder="$t('email_placeholder')"
                    aria-describedby="email-feedback"
                    class="form-control"
                  ></b-form-input>
                  <b-form-invalid-feedback id="email-feedback">
                    {{ loginValidation.emailError }}
                  </b-form-invalid-feedback>
                </b-form-group>

                 <p class="mt-n4 mb-4 pb-3 login-desc d-block d-md-none pt-3 pt-md-0 p-2 p-md-0">{{ $t("required_fields") }}</p>
                <b-form-group
                  class="mb-3 mb-md-4 pb-0 pb-md-4 form-label"
                  id="password-group"
                  :label="$t('form_password') + '*'"
                  label-for="password"
                >
                  <b-form-input
                    id="password"
                    v-model="loginData.password"
                    type="password"
                    :state="loginValidation.passwordState"
                    @blur="validatePassword"
                    :placeholder="$t('password_placeholder')"
                    aria-describedby="password-feedback"
                    class="form-control"
                  ></b-form-input>
                  <b-form-invalid-feedback id="password-feedback">
                    {{ loginValidation.passwordError }}
                  </b-form-invalid-feedback>
                </b-form-group>
                <p class="mt-n4 mb-4 pb-3 login-desc d-none d-md-block">{{ $t("required_fields") }}</p>
                <router-link
                  :to="{ name: 'forgotPassword' }"
                  style="text-decoration: underline;" class="forgot-password d-block d-md-none pb-4 pb-md-0 p-2 p-md-0"
                  >{{ $t("password_forgot_login_form") }}
                </router-link>
                <button class="btn btn-primary btn-lg mb-3 w-100" type="submit">
                  {{ $t("login") }}
                </button>
                <router-link
                  :to="{ name: 'forgotPassword' }"
                  style="text-decoration: underline;" class="forgot-password d-none d-md-block"
                  >{{ $t("password_forgot_login_form") }}
                </router-link>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Login from "@storefront/core/modules/user/mixins/login";
import { Logger } from "@storefront/core/lib/logger";
import config from "@config";
import Breadcrumbs from "@/esf_antarctica_lederhosenland/core/components/breadcrumb/Breadcrumbs.vue";

export default {
  name: "Login",
  mixins: [Login],
  components: {
    Breadcrumbs
  },
  data() {
    return {
      loginValidation: {
        emailState: null,
        emailError: "",
        passwordState: null,
        passwordError: "",
        // valid: true,
        // email: {
        //   valid: true,
        //   msg: "",
        // },
        // password: {
        //   valid: true,
        //   msg: "",
        // },
      },
    };
  },

  computed: {
    isLoggedIn() {
      return this.$store.getters["user/getIsLoggedIn"];
    },
  },
  watch: {
    isLoggedIn() {
      if (this.$store.getters["user/getIsLoggedIn"] == true) {
        this.$router.push({ name: "account" });
      }
    },
  },
  mounted() {
    const bcrumb = { current: this.$t("login"), routes: [] };
    this.$store.commit("breadcrumbs/set", bcrumb);
  },

  methods: {
    onLoginFormSubmit() {
      let formValid = true;
      if (this.loginValidation.emailState != true) {
        this.validateEmail();
        if (this.loginValidation.emailState != true) {
          formValid = false;
        }
      }
      Logger.debug("onLoginFormSubmit", "email", formValid)();

      if (this.loginValidation.passwordState != true) {
        this.validatePassword();
        if (this.loginValidation.passwordState != true) {
          formValid = false;
        }
      }

      if (formValid == true) {
        this.login();
      }
    },

    // validateForm() {
    //   this.loginValidation.valid = true;
    //   if (this.loginData.email == "") {
    //     this.loginValidation.valid = false;
    //     this.loginValidation.email.valid = false;
    //     this.loginValidation.email.msg = this.$t("email_is_required_field");
    //     // this.loginValidation.email.msg = "Field is required.";
    //   } else if (!this.emailReg.test(this.loginData.email)) {
    //     this.loginValidation.valid = false;
    //     this.loginValidation.email.valid = false;
    //     this.loginValidation.email.msg = this.$t("email_is_invalid_field");
    //     // this.loginValidation.email.msg = "Please enter valid email.";
    //   } else {
    //     this.loginValidation.email.valid = true;
    //     this.loginValidation.email.msg = "";
    //   }
    //   if (this.loginData.password == "") {
    //     this.loginValidation.valid = false;
    //     this.loginValidation.password.valid = false;
    //     this.loginValidation.password.msg = this.$t(
    //       "password_is_required_field"
    //     );
    //     // this.loginValidation.password.msg = "Field is required.";
    //   } else {
    //     this.loginValidation.password.valid = true;
    //     this.loginValidation.password.msg = "";
    //   }

    //   if (this.loginValidation.valid) {
    //     this.login();
    //   }
    // },

    validateEmail() {
      if (this.loginData.email.length == 0) {
        this.loginValidation.emailState = false;
        this.loginValidation.emailError = this.$t("email_is_required_field");
        return false;
      }
      if (!this.emailReg.test(this.loginData.email)) {
        this.loginValidation.emailState = false;
        this.loginValidation.emailError = this.$t("email_is_invalid_field");
        return false;
      }
      this.loginValidation.emailState = true;
      return true;
    },

    validatePassword() {
      if (this.loginData.password.length == 0) {
        this.loginValidation.passwordState = false;
        this.loginValidation.passwordError = this.$t(
          "password_is_required_field"
        );
        return false;
      }
      this.loginValidation.passwordState = true;
      return true;
    },
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "title",
          content: this.$t("login"),
        },
        { name: "keywords", content: this.$t("login") },
        { name: "description", content: this.$t("login") },
      ],
      //test 3
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.$t("login"),
      // all titles will be injected into this template
      link: [{ rel: "canonical", href: config.app_url + this.$route.fullPath }],
    };
  },
};
</script>

<style></style>
